import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../landingPage/home.module.css';

function Safety() {
  return (
    <>
      {/* Header */}
      <section className={`${styles.header} ${styles.headerCs}`}>
        <div className={`container ${styles.container}`}>
          <div className={styles.logo}>
            <Link to="/">
              <img src={window.getPublicUrl("/images/logo-2.svg")} alt="ResuMate Logo" />
            </Link>
          </div>
          <div className={styles.social}>
             <ul className='terms-list'>
              <li><a href=""><img src={window.getPublicUrl("/images/insta.svg")} alt="Instagram" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/fb.svg")} alt="Facebook" /></a></li>
              <li><a href=""><img src={window.getPublicUrl("/images/tik.svg")} alt="TikTok" /></a></li>
            </ul>
          </div>
        </div>
      </section>

    <main className="terms-container faq  terms-nd-condition my-3">
      <div  className={`container ${styles.container}`}>
      <header className="terms-header">
      </header>
      </div>
    </main>
   <main className="terms-container faq  terms-nd-condition my-3">
       <div  className={`container ${styles.container}`}>
       <header className="terms-header">
         <h1 className='main-heading text-left'>Resumate Child Safety & CSAM Prevention Standards</h1>
         <p>Last updated: November 15, 2025</p>
         <p>
          Resumate is committed to protecting the safety and well-being of all users on our platform. We maintain strict standards to prevent child sexual abuse and exploitation (CSAE), detect and report child sexual abuse material (CSAM), and ensure safe interactions between adult users.
         </p>
         <p>
          These standards apply to all users, content, and activity on Resumate.
         </p>
       </header>

       <article>
         <h2 className='inner-heading'>🔒 1. Zero-Tolerance Policy for CSAM & Child Exploitation</h2>
         <p>Resumate prohibits:</p>
          <ul className='terms-list'>
           <li>Child sexual abuse material (CSAM)</li>
           <li>Sexualized content involving minors</li>
           <li>Grooming, enticement, or exploitation</li>
           <li>Attempts to contact minors for sexual purposes</li>
           <li>Any content that suggests, encourages, or normalizes sexual behavior involving minors</li>
           <li>All violations result in immediate account removal and mandatory reporting to authorities.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>👥 2. Age Requirements</h2>
         <p>Resumate is strictly for adults 18 and older.</p>
         <p>We enforce this through:</p>
          <ul className='terms-list'>
           <li>Age-gating during account creation</li>
           <li>Profile monitoring and automated flagging</li>
           <li>Mandatory removal and banning of accounts suspected to belong to minors</li>
           <li>Reporting of attempted minor impersonation</li>
           <li>Users may be required to provide proof of age if there is suspicion of underage activity.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>🛡️ 3. CSAM Detection & Moderation</h2>
         <p>To prevent CSAM appearing on our platform, Resumate uses:</p>
          <ul className='terms-list'>
           <li>Automated detection tools</li>
           <li>Human moderator review</li>
           <li>Keyword/behavioral filters</li>
           <li>Photo & content verification processes</li>
           <li>Moderators receive ongoing training in identifying CSAM and related threats.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>🚨 4. Reporting CSAM to Authorities</h2>
         <p>Resumate complies with all regional and national reporting laws.</p>
         <p>When CSAM or attempted exploitation is detected, we immediately:</p>
          <ul className='terms-list'>
           <li>Remove the content</li>
           <li>Suspend or ban the account</li>
           <li>Report to appropriate authorities (e.g., NCMEC in the U.S. and equivalent agencies internationally)</li>
           <li>We cooperate fully with law enforcement investigations.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>📢 5. How Users Can Report Safety Concerns</h2>
         <p>Users can report:</p>
          <ul className='terms-list'>
           <li>Underage users</li>
           <li>Suspicious behavior</li>
           <li>Sexual exploitation</li>
           <li>Inappropriate content</li>
           <li>CSAM or grooming attempts</li>
           <li>In-app reporting: Users can report directly from any profile or message.</li>
           <li>Email reporting: <a className='email'>sparklefromwithinllc@gmail.com</a> (Our designated safety contact.)</li>
           <li>All reports are reviewed promptly and confidentially.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>🧭 6. Behavior & Interaction Standards</h2>
         <p>The following actions are strictly prohibited:</p>
          <ul className='terms-list'>
           <li>Requesting sexual content from others</li>
           <li>Sharing sexual content involving minors</li>
           <li>Attempting to meet an individual known or suspected to be a minor</li>
           <li>Harassment, threats, or coercive behavior</li>
           <li>Predatory or manipulative behavior</li>
           <li>Users who violate these rules will be banned permanently.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>⚖️ 7. Enforcement Actions</h2>
         <p>Depending on severity, enforcement may include:</p>
          <ul className='terms-list'>
           <li>Content removal</li>
           <li>Temporary suspension</li>
           <li>Permanent account ban</li>
           <li>Device blocking</li>
           <li>Reporting to law enforcement or relevant agencies</li>
           <li>We apply the strongest penalties for child safety violations.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>🔍 8. Continuous Improvement & Monitoring</h2>
         <p>Resumate routinely:</p>
          <ul className='terms-list'>
           <li>Updates detection systems</li>
           <li>Improves moderation tools</li>
           <li>Reviews safety policies</li>
           <li>Trains moderators on emerging threats</li>
           <li>Conducts audits of safety procedures</li>
           <li>Our commitment to child safety is ongoing and evolving.</li>
         </ul>
       </article>

       <article>
         <h2 className='inner-heading'>📧 9. Contact Information</h2>
         <p>For questions or concerns regarding child safety or CSAM prevention, contact our designated safety officer:</p>
          <p><a className='email'>sparklefromwithinllc@gmail.com</a></p>
       </article>

       <article>
         <h2 className='inner-heading'>📝 10. Compliance Statement</h2>
          <ul className='terms-list'>
           <li>Resumate complies with all applicable child protection laws and industry standards.</li>
           <li>We report CSAM and attempted exploitation to regional and national authorities as required.</li>
         </ul>
       </article>

       <footer className="terms-footer">
         © {new Date().getFullYear()} Resumate. All rights reserved.
       </footer>
       </div>
     </main>
      {/* Footer */}
      <section className={styles.footer}>
        <div className={`container ${styles.container}`}>
          <div className="row">
            <div className="col-sm-4">
              <div className={styles.footerLeft}>
                <a href=""><img src={window.getPublicUrl("/images/footer-logo.svg")} /></a>
              </div>
                      <div className={`${styles.footerMid} ${styles.right}`}>
                <h4>Follow us</h4>
                 <ul className='terms-list'>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social1.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social2.svg")} /></a></li>
                  <li><a href=""><img src={window.getPublicUrl("/images/footer-social3.svg")} /></a></li>
                </ul>
              </div>

            </div>
            <div className="col-sm-4">
                      <div>
                <ul className={styles.termsConditonList}>
                  <li><Link to="/terms&condition">Terms & Conditions</Link></li>
                  <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
                  <li><Link to="/communityGuidelines">Community Guidelines</Link></li>
                  <li><Link to="/eula">EULA</Link></li>
                  <li><Link to="/safety">Safety</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-sm-4">
                  <div className={styles.footerMid}>
                <h4 className="text-right">Get the app</h4>
                <ul className="text-right">
                  <li><a href="https://apps.apple.com/us/app/resumate-app/id6754164064
"><img src={window.getPublicUrl("/images/app2.svg")} /></a></li>
                  <li><a href="https://play.google.com/store/apps/details?id=com.resumate"><img src={window.getPublicUrl("/images/goog2.svg")} /></a></li>                </ul>
              </div>

            </div>
            <div className="col-sm-12">
              <h5>Copyright © 2025 Resumate.  All rights reserved.</h5>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Safety;

